export const ORDER_CONFIG = {
    PENDING: {
        label: "Pending",
        color: "#92400E", bg: "#FFFBEB", border: "#FDE68A", dot: "#F59E0B",
        iconName: "solar:clock-circle-bold",
    },
    INPROGRESS: {
        label: "In Progress",
        color: "#1E40AF", bg: "#EFF6FF", border: "#BFDBFE", dot: "#3B82F6",
        iconName: "solar:refresh-circle-bold",
    },
    COMPLETED: {
        label: "Completed",
        color: "#065F46", bg: "#ECFDF5", border: "#A7F3D0", dot: "#10B981",
        iconName: "solar:check-circle-bold",
    },
    CANCELLED: {
        label: "Cancelled",
        color: "#374151", bg: "#F9FAFB", border: "#E5E7EB", dot: "#9CA3AF",
        iconName: "solar:close-circle-bold",
    },
    FAILED: {
        label: "Failed",
        color: "#991B1B", bg: "#FFF1F2", border: "#FECDD3", dot: "#F43F5E",
        iconName: "solar:danger-circle-bold",
    },
    ONHOLD: {
        label: "On Hold",
        color: "#6B21A8", bg: "#FAF5FF", border: "#E9D5FF", dot: "#A855F7",
        iconName: "solar:pause-circle-bold",
    },
};